// extracted by mini-css-extract-plugin
export default {"v-graphite":"#4A4A4A","v-white":"#FFF","list":"dropdown_list__list__uEO__","listItem":"dropdown_list__listItem__gz6Yn","focused":"dropdown_list__focused__B7WTh"};